import { api } from '@/app'
import { WebInputFile } from '@codeleap/common'
import { Upload } from 'tus-js-client'

export type VideoUploadParams = {
  url: string
  headers: {
    VideoId: string
    AuthorizationSignature: string
    AuthorizationExpire: string
    LibraryId: string
  }
}

export const getVideoUploadParams = async (file: WebInputFile['file'], title?: string) => {
  const filename = file?.name

  const response = await api.post<VideoUploadParams>(`bunny/presign/`, {
    filename: filename,
    title: title ?? filename,
  })

  return response.data
}

export const tusUpload = (file: WebInputFile['file'], uploadParams: VideoUploadParams) => {
  console.log('tusUpload uploadParams', uploadParams)

  return new Promise<void>((resolve, reject) => {
    const upload = new Upload(file, {
      endpoint: uploadParams.url,
      headers: uploadParams.headers,
      chunkSize: 5 * 1024 * 1024,
      onError: error => {
        console.log('Error in TUS Upload', error)
        reject(error)
      },
      onProgress: function (bytesUploaded, bytesTotal) {
        const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2)
        console.log('TUS Upload', bytesUploaded, bytesTotal, percentage + '%')
      },
      onSuccess: payload => {
        console.log('Success in TUS Upload', payload)
        resolve()
      },
    })

    upload.start()
  })
}

type CommunityParams = {
  image?: WebInputFile
  video?: WebInputFile
  title?: string
}

export const prepareCommunityBody = async <T extends CommunityParams>(params: T) => {
  const { image, video, ...data } = params

  const form = new FormData()

  if (image) {
    form.set('image', image.file)
  } else if (video) {
    const uploadParams = await getVideoUploadParams(video?.file, data.title)

    form.set('video', uploadParams.headers.VideoId)

    await tusUpload(video?.file, uploadParams)
  }

  for (const [key, value] of Object.entries(data)) {
    form.set(key, value)
  }

  return form
}
